import { css, extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  body: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 16px;
  `,
  currentStatus: css`
    display: flex;
    align-items: center;
    gap: 4px;
    justify-content: flex-start;
  `,
  refreshStatusContainer: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
  `,
  refreshStatus: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    flex-shrink: 0;

    ${extractTransition((f) => f.cubic, { duration: 330, property: ['background-color'] })}

    &:hover {
      cursor: pointer;
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
  footer: css`
    display: flex;
    align-items: center;
  `,
  footerActions: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-left: auto;
    gap: 8px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
